export function getCustomMethod(state) {
	return state.customMethod	
}
